import {apiClient} from '../apiClient';
import {ExportTrueLawConfirmationRequest} from '../types/exportTrueLaw.type';
const BASE_URL = 'searching/api/v1/savedsearch';

export const SaveExportConfirmation = async (
  payload: ExportTrueLawConfirmationRequest
): Promise<string> => {
  const response = await apiClient.post<string>(
    `${BASE_URL}/truelaw/confirmation`,
    payload,
    {
      headers: {
        accept: 'text/plain',
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};
